import React from 'react';
import { StyledCareerHistoryLink, StyledCareerIcon } from './styled';

export default function CareerHistoryLink({ playerId }) {
  if (!playerId) return null;

  return (
    <StyledCareerHistoryLink to={`/league/career/${playerId}`}>
      <StyledCareerIcon aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12a9 9 0 1 0 3-6.7" />
          <path d="M3 4v5h5" />
          <path d="M12 7v5l3 2" />
        </svg>
      </StyledCareerIcon>
      <span>Career History</span>
    </StyledCareerHistoryLink>
  );
}
